export enum SnackbarTestIds {
  ROOT = 'snackbar',
  TITLE = 'snackbar-title',
  MESSAGE = 'snackbar-message',
  CLOSE = 'snackbar-close',
}
